/* eslint-disable @typescript-eslint/no-explicit-any */
import { cascadeEval } from 'utils/conditions';
import { TableColumn } from '../../types';

export function getColumnKey({ property, label, id }: TableColumn<any>, index: number): string {
  return cascadeEval([
    { is: id ?? property, then: id ?? property },
    { is: typeof label === 'string', then: label },
    { is: true, then: `__${index}__` },
  ]) as string;
}

const validTypes = ['string', 'number', 'boolean'];

export function getEntryValue<Item>(
  item: Item,
  column: TableColumn<Item>,
  refProperty?: string | keyof Item,
): any {
  const { render, getTextValue, property } = column;

  const prop = refProperty ?? property;

  const propValue = prop ? item[prop as keyof Item] : null;

  const refValue = [
    // preference order
    getTextValue?.(item),
    render?.(item),
    propValue,
  ].find((value) => validTypes.includes(typeof value));

  return refValue;
}
